import React, {Component} from 'react';
import { storage } from "../firebase";
import axios from 'axios'
import {Button, Col, Form, FormControl, InputGroup, Modal, ProgressBar} from "react-bootstrap";
import {NavLink} from "react-router-dom";

class Add extends Component {

    state = {
        image: null,
        url: '',
        progress: 0,
        name: '',
        surName: '',
        lastName: '',
        rank: '',
        bornDate: '',
        deathDate: '',
        information: '',
        show: false
    };

    nameHandler = event => {
        const data = event.target.value;
        this.setState({
            name: data
        })
    };

    surNameHandler = event => {
        const data = event.target.value;
        this.setState({
            surName: data
        })
    };

    lastNameHandler = event => {
        const data = event.target.value;
        this.setState({
            lastName: data
        })
    };

    bornDateHandler = event => {
        const data = event.target.value;
        this.setState({
            bornDate: data
        })
    };

    deathDateHandler = event => {
        const data = event.target.value;
        this.setState({
            deathDate: data
        })
    };

    rankHandler = event => {
        const data = event.target.value;
        this.setState({
            rank: data
        })
    };

    infoHandler = event => {
        const data = event.target.value;
        this.setState({
            information: data
        })
    };

    handleChange = event => {
        const image = event.target.files[0];
        if (image) {
            this.setState({
                image
            });

            const uploadTask = storage.ref(`images/${image.name}`).put(image);
            uploadTask.on(
                "state_changed",
                snapshot => {
                    const progress = Math.round(
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    );
                    this.setState({
                        progress
                    })
                },
                error => {
                    console.log(error);
                },
                () => {
                    storage
                        .ref("images")
                        .child(image.name)
                        .getDownloadURL()
                        .then(url => {
                            this.setState({
                                url
                            })
                        });
                }
            );
        }
    };

    trueHandler = async event => {
        event.preventDefault();
        console.log(this.state.deathDate);
        try {
            await axios.post('https://bgn-heroes.firebaseio.com/persons.json',
                {
                    url: this.state.url,
                    name: `${this.state.surName} ${this.state.name} ${this.state.lastName}`,
                    rank: this.state.rank,
                    lifeTime: `Годы жизни: c ${this.state.bornDate === '' ? 'Неизвестно' : this.state.bornDate} по ${this.state.deathDate === '' ? 'Неизвестно' : this.state.deathDate}`,
                    information: this.state.information
                });
        } catch (e) {
            console.log(e)
        }
        this.setState({
            show: true
        })
    };

    render() {
        return (
            <div className={'Add'}>
                <Modal show={this.state.show}>
                    <Modal.Header>
                        <Modal.Title>Герой успешно добавлен!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Спасибо! <br/> Загрузка прошла успешно. <br/> Перейдите по ссылке ниже, чтобы просмотреть изменения</Modal.Body>
                    <Modal.Footer>
                        <NavLink to={'/'} exact>
                            <Button variant="primary">
                                Вернуться в список героев
                            </Button>
                        </NavLink>
                    </Modal.Footer>
                </Modal>
                <h1>Добавить героя</h1>
                <NavLink to={'/'} exact>
                    ← Вернуться на главную
                </NavLink>
                <Form>
                    <Form.Row>
                        <Form.Group as={Col} controlId="surName">
                            <Form.Label>Фамилия</Form.Label>
                            <Form.Control type="text" placeholder="Матвеев" onChange={this.surNameHandler} />
                        </Form.Group>

                        <Form.Group as={Col} controlId="name">
                            <Form.Label>Имя</Form.Label>
                            <Form.Control type="text" placeholder="Иван" onChange={this.nameHandler} />
                        </Form.Group>

                        <Form.Group as={Col} controlId="lastName">
                            <Form.Label>Отчество</Form.Label>
                            <Form.Control type="text" placeholder="Владимирович" onChange={this.lastNameHandler} />
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} controlId="bornDate">
                            <Form.Label>Дата рождения</Form.Label>
                            <Form.Control placeholder="12.03.1901" onChange={this.bornDateHandler} />
                            <Form.Text className="text-muted">
                                Если вы не знаете дату рождения, можете указать год или оставить поле пустым
                            </Form.Text>
                        </Form.Group>

                        <Form.Group as={Col} controlId="deathDate">
                            <Form.Label>Дата смерти</Form.Label>
                            <Form.Control placeholder="15.11.1943" onChange={this.deathDateHandler} />
                            <Form.Text className="text-muted">
                                Если вы не знаете дату смерти, можете указать год или оставить поле пустым
                            </Form.Text>
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} controlId="rank">
                            <Form.Label>Звание</Form.Label>
                            <Form.Control placeholder="Введите звание" onChange={this.rankHandler} />
                            <Form.Text className="text-muted">
                                Если вы не знаете звание, можете оставить поле пустым
                            </Form.Text>
                        </Form.Group>

                        <Form.Group as={Col} controlId="picture">
                            <Form.Label>Фотография героя</Form.Label>
                            <Form.File
                                id="picture"
                                label="Выберите фотографию"
                                custom
                                data-browse="Выбрать"
                                onChange={this.handleChange}
                                accept="image/*,image/jpeg"
                            />
                            <Form.Text className="text-muted">
                                Пожалуйста, выберите фотографию подобную размером 350x450 (В ФОРМАТЕ JGP)
                            </Form.Text>
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label>Просмотр фотографии</Form.Label>
                            <ProgressBar now={this.state.progress} max={100} />
                            <img src={this.state.url || "http://via.placeholder.com/300x450"} alt="firebase-image" />
                        </Form.Group>

                        <Form.Group as={Col} controlId="information">
                            <Form.Label>Информация о герое</Form.Label>
                            <FormControl as="textarea" placeholder="Информация" aria-label="нформация о герое" onChange={this.infoHandler}/>
                        </Form.Group>

                        <Form.Group as={Col} controlId="dop">
                            <Form.Label>Памятка пользования</Form.Label>
                            <Form.Text className="text-muted">
                                1) Заполните все поля формы <br/><br/>
                                2) Обратите внимание, что поля "Дата рождения/смерти", "Звание", "Фотография" можно оставить пустыми, если у вас нет информации. <br/><br/>
                                3) Остальные поля для заполнения - обязательны <br/><br/>
                                4) После заполения всех полей, нажмите на кнопку "Добавить героя"<br/><br/>
                                5) Перейдите на главную страницу и убедитесь, что информация добавлена.<br/><br/>
                                Фотография загружается автоматически после выбора.
                            </Form.Text>
                        </Form.Group>
                    </Form.Row>

                    <hr/>

                    {(this.state.name === '') || (this.state.surName === '') || (this.state.lastName === '') || (this.state.information === '') ?
                        <Button disabled variant="primary" type="submit" onClick={this.trueHandler}>
                            Добавить героя
                        </Button> :
                        <Button variant="primary" type="submit" onClick={this.trueHandler}>
                            Добавить героя
                        </Button>
                    }
                </Form>
            </div>
        );
    }
}

export default Add;